export default __webpack_public_path__ + "assets/images/logo-web-application-5x5.png";